<template>
  <v-dialog v-model="show" max-width="800">
    <v-card>
      <v-card-title class="body-1">
        {{ title }}
        <v-spacer></v-spacer>
        <v-btn icon small @click="show = false">
          <v-icon small>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <fleet-form
          @valid="saveButtonDisabled = false"
          @invalid="saveButtonDisabled = true"
        />
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          class="secondary--text"
          :disabled="saveButtonDisabled"
          @click="saveFleet()"
        >
          {{ $vuetify.lang.t('$vuetify.SAVE') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import Fleet from '@/models/fleet'
import { mapGetters } from 'vuex'

export default {
  name: 'EditFleetDialog',
  components: {
    FleetForm: () =>
      import(
        /* webpackChunkName: "FleetForm" */ '@/components/fleets/FleetForm'
      )
  },
  props: {
    visible: {
      type: Boolean,
      required: true,
      default: false
    },
    title: {
      type: String,
      required: false,
      default: ''
    }
  },
  data() {
    return {
      saveButtonDisabled: true
    }
  },
  computed: {
    ...mapGetters('app', ['error']),
    show: {
      get() {
        return this.visible
      },
      set(value) {
        if (!value) {
          this.$emit('close')
          this.$store.commit('fleets/setCurrentFleetId', null)
          this.$store.commit('fleets/setFleet', new Fleet().getObject())
        }
      }
    }
  },
  methods: {
    async saveFleet() {
      try {
        await this.$store.dispatch(
          'fleets/postFleet',
          this.$store.state.fleets.fleet
        )
        this.show = false
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('Error in saveFleet:', error)
      }
    }
  }
}
</script>
